import { render, staticRenderFns } from "./CField.vue?vue&type=template&id=27411907"
import script from "./CField.vue?vue&type=script&lang=js"
export * from "./CField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27411907')) {
      api.createRecord('27411907', component.options)
    } else {
      api.reload('27411907', component.options)
    }
    module.hot.accept("./CField.vue?vue&type=template&id=27411907", function () {
      api.rerender('27411907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CField.vue"
export default component.exports